var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("DAStoreList.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row-direction" },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "row-bg",
                          attrs: { type: "flex", justify: "space-between" },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "DAStoreList.form.customerNumber"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("common.pleaseInput"),
                                      autocomplete: "off",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchVal.rtlSapId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.searchVal, "rtlSapId", $$v)
                                      },
                                      expression: "searchVal.rtlSapId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("DAStoreList.form.storeName"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("common.pleaseInput"),
                                      autocomplete: "off",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchVal.rtlFullName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchVal,
                                          "rtlFullName",
                                          $$v
                                        )
                                      },
                                      expression: "searchVal.rtlFullName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("DAStoreList.form.RTMType"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: _vm.$t(
                                          "common.pleaseSelect"
                                        ),
                                      },
                                      model: {
                                        value: _vm.searchVal.rtlRtmCategory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchVal,
                                            "rtlRtmCategory",
                                            $$v
                                          )
                                        },
                                        expression: "searchVal.rtlRtmCategory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.lookupList["STORE_RTM_TYPE"],
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "DAStoreList.form.retailStoreCategory"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.retailerType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "retailerType",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.retailerType",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_CATEGORY"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.provinceCityDistrict"
                                ),
                              },
                            },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "DAStoreList.form.cascaderPlaceholder"
                                  ),
                                  options: _vm.regionOptions,
                                  "collapse-tags": "",
                                  clearable: "",
                                  props: {
                                    multiple: true,
                                    checkStrictly: false,
                                    value: "label",
                                  },
                                },
                                on: {
                                  clear: _vm.pcdClearEvent,
                                  change: _vm.pcdChangeEvent,
                                },
                                model: {
                                  value: _vm.region,
                                  callback: function ($$v) {
                                    _vm.region = $$v
                                  },
                                  expression: "region",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("DAStoreList.form.address"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.rtlAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "rtlAddress", $$v)
                                  },
                                  expression: "searchVal.rtlAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("DAStoreList.form.SRNO") },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.empNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "empNo", $$v)
                                  },
                                  expression: "searchVal.empNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("DAStoreList.form.SRName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.empName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "empName", $$v)
                                  },
                                  expression: "searchVal.empName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("DAStoreList.form.spFullName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.spFullName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "spFullName", $$v)
                                  },
                                  expression: "searchVal.spFullName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              attrs: { slot: "footer-right" },
              slot: "footer-right",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("DAStoreList.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["IMPORT"] },
                    expression: "{pageName, list: ['IMPORT']}",
                  },
                ],
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("DAStoreList.common.exportText")
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("organizationArchitecture.btn.export"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "excel-upload-input",
                    staticStyle: { display: "inline" },
                    attrs: {
                      action: "",
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".xlsx, .xls, .xlsm, .csv",
                      "on-change": _vm.uploadData,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", size: "small" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.file
                              ? _vm.$t("organizationArchitecture.btn.resetFile")
                              : _vm.$t("organizationArchitecture.btn.import")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rtlSapId",
                  label: _vm.$t("DAStoreList.table.customerNumber"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("DAStoreList.table.storeName"),
                  "min-width": "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DAStoreList.table.RTMType"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["STORE_RTM_TYPE_MAPPING"] &&
                                  _vm.lookupList["STORE_RTM_TYPE_MAPPING"][
                                    scope.row.rtlRtmCategory
                                  ]) ||
                                  scope.row.rtlRtmCategory
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DAStoreList.table.retailStoreCategory"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["STORE_CATEGORY_MAPPING"] &&
                                  _vm.lookupList["STORE_CATEGORY_MAPPING"][
                                    scope.row.retailerType
                                  ]) ||
                                  scope.row.retailerType
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("DAStoreList.table.SRNO"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("DAStoreList.table.SRName"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spFullName",
                  label: _vm.$t("DAStoreList.table.spFullName"),
                  "min-width": "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remarkOne",
                  label: _vm.$t("DAStoreList.table.remarkOne"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remarkTwo",
                  label: _vm.$t("DAStoreList.table.remarkTwo"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remarkThree",
                  label: _vm.$t("DAStoreList.table.remarkThree"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlRegion",
                  label: _vm.$t("DAStoreList.table.province"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlCity",
                  label: _vm.$t("DAStoreList.table.city"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlDistrict",
                  label: _vm.$t("DAStoreList.table.area"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlAddress",
                  label: _vm.$t("DAStoreList.table.address"),
                  "min-width": "280",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "detail-model",
          attrs: {
            width: "900px",
            title: "导入结果",
            visible: _vm.isShowModel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c("Detail", {
            attrs: { "batch-id": _vm.excelBatchId, "is-error": _vm.isError },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.downloadResultExcel(
                        _vm.$t("DAStoreList.common.exportText")
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.exportResult")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isShowModel = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.isShowProgress,
            "dialog-status": "导入进度",
            "show-close": _vm.showClose,
            "is-hide-footer": !_vm.showClose,
            "confirm-btn-text": _vm.confirmText,
            "save-item": _vm.handleClickConfirm,
            width: "1200px",
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowProgress = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowProgress = $event
            },
          },
        },
        [
          _vm.isShowProgress
            ? _c("Progress", {
                ref: "progress",
                attrs: {
                  "show-result": _vm.showResult,
                  "file-import-process-unique-code":
                    _vm.fileImportProcessUniqueCode,
                  "show-close": _vm.showClose,
                },
                on: {
                  "update:showClose": function ($event) {
                    _vm.showClose = $event
                  },
                  "update:show-close": function ($event) {
                    _vm.showClose = $event
                  },
                  error: _vm.handleError,
                  animeSuccess: _vm.handleEnd,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }